import styled from "@emotion/styled";
import { ThemeStyle } from "assets/scss/common/theme";


export const ToastWrapper = styled.div`
  position: fixed;
  bottom: 98px;
  margin: 0 20px;
  padding: 16px;
  background: ${({ theme }: ThemeStyle) => theme.colors.primary};
  color: ${({ theme }: ThemeStyle) => theme.colors.white};
  width: calc(100% - 40px);
  text-align: center;
`;
